import React, { Fragment } from "react";
import { Href } from "../../../../Constant";
import { COLOURED_BREADCRUMB_LIST } from "../../../../Data/Bonus Ui/Breadcrumb";
import { OL } from "../../../../AbstractElements";
import { BreadcrumbItem } from "reactstrap";

export const DynamicColoredBreadcrumb = () => {
  return (
    <>
      {COLOURED_BREADCRUMB_LIST.map(({ className, span }, index) => (
        <OL className={`breadcrumb breadcrumb-colored ${className}`} key={index}>
          {span.map(({ title, activeTitle }, index) => (
            <Fragment key={index}>
              {title && (
                <BreadcrumbItem><a className="fw-bold" href={Href}>{title}</a></BreadcrumbItem>
              )}
              {activeTitle && <BreadcrumbItem active className="fw-bold bg-transparent">{activeTitle}</BreadcrumbItem>}
            </Fragment>
          ))}
        </OL>
      ))}
    </>
  );
};
